"use client";
import { useLayoutEffect, useState } from "react";

import usePersistedStore from "@/lib/stateManagement/persistedState/persistedStore";

import styles from "./device.module.css";

type Props = {
  children?: React.ReactNode;
};

const Device: React.FC<Props> = ({ children }) => {
  const { setIsMobile, setIsDesktop, setHasWindow } = usePersistedStore(
    (state) => ({
      setIsMobile: state.setIsMobile,
      setIsDesktop: state.setIsDesktop,
      setHasWindow: state.setHasWindow,
      setPreview: state.setPreview,
      environment: state.environment,
    })
  );
  const [lastWindowState, setLastWindowState] = useState(false);

  const useBrowserLayoutEffect =
    typeof window !== "undefined" ? useLayoutEffect : () => {};

  if (
    typeof window !== "undefined" &&
    (typeof window !== "undefined") !== lastWindowState
  ) {
    setHasWindow(typeof window !== "undefined");
    setLastWindowState(typeof window !== "undefined");
  }

  const maxMobileSize = styles.maxMobilesize || "1024px";
  const mobileSizeMatch = maxMobileSize.match(/^d+/);
  const mobileSizeNumber =
    mobileSizeMatch && mobileSizeMatch[0] ? +mobileSizeMatch[0] : 1024;

  useBrowserLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= mobileSizeNumber);
      setIsDesktop(window.innerWidth > mobileSizeNumber);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return <>{children}</>;
};

export default Device;
